import { memo } from 'react'

import type { ToastListItem } from './toast.types'

import { Box } from '../box'
import { v } from '../core/styled'
import { useVuiContext } from '../core/vuiProvider/context'
import zIndices from '../theme/foundations/zIndices'

export { ToastItem } from './ToastItem'
export type { ToastItemProps } from './ToastItem'

export const toasterWidth = 480

const Toaster = () => {
  const { toasts } = useVuiContext()

  const right = { md: '1rem', sm: '0.5rem', xs: '0.5rem' }
  const width = { md: 560, sm: 560, xs: '100%' }
  const bottom = toasts?.list?.length ? '1rem' : '-2rem'

  return (
    <Box
      bottom={bottom}
      className="vui-toaster"
      alignItems="flex-end"
      display="flex"
      flexDirection="column"
      gap="8px"
      maxW={width}
      minW={width}
      position="fixed"
      right={right}
      zIndex={zIndices.toast}
    >
      {toasts?.list?.map?.((toast: ToastListItem) => (
        <v.div id={`toast_${toast.id}`} key={toast.id}>
          {toast.component}
        </v.div>
      ))}
    </Box>
  )
}

export default memo(Toaster)
